var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.707 18.707a1 1 0 0 0 0-1.414L5.414 13H21a1 1 0 1 0 0-2H5.414l4.293-4.293a1 1 0 0 0-1.414-1.414l-6 6A.996.996 0 0 0 2 12m.076.383a.998.998 0 0 0 .217.324l6 6a1 1 0 0 0 1.414 0M2 12.01a.997.997 0 0 0 .076.374L2 12.009Z",
    fill: "currentColor"
  })));
};
export default SvgBackArrow;